import { Separator as ChakraSeparator } from '@chakra-ui/react'

export const Separator = ChakraSeparator
